import axios from "axios";
import { API_URL } from "@helpers";

export const getNumber = () => {
    return axios.get(`${API_URL}/get_counter`);
};
